import moment from 'moment';
import { formatDate, formatRupiah, isEmptyData, sendAnalyticsEvent } from '../../utils/helper';
import ImageLoader from '../ImageLoader';
import { useMemo } from 'react';
import { DiscountIcon } from '../../utils/svg';
import { showError } from '../../ufood-x/hook/useError';
import { VOUCHER_GLOBAL_PURPOSE } from '../../utils/constants';
import { useSelector } from 'react-redux';
import { cleanText } from '../../utils/helper';

const VoucherGlobal = (props) => {
	const user = useSelector((store) => store?.user);
	const {
		data = {},
		handleUseVoucher = (data) => {},
		type = 'my_voucher',
		showLabelCount = false,
		isDisabled = false,
		onOpenDetail = () => {},
		remainingNominal = 0,
		isHiddenButton = false,
		values,
		isLoading = false,
		isPending = false,
	} = props;
	const isOneSmile = user?.is_b2b && cleanText(user?.companyName) === 'onesmile';

	const expired = useMemo(() => {
		if (data?.periode_type === 'date_range') {
			return `Expired ${formatDate(data?.end_date, 'DD MMM YYYY')}`;
		}

		if (data?.periode_type === 'day_time') {
			const todayName = moment().format('dddd');
			const now = moment();
			const todaySchedule = data.day_scope?.find((d) => d.day.toLowerCase() === todayName.toLowerCase());

			const start = moment(todaySchedule?.start_time, 'HH:mm');
			const end = moment(todaySchedule?.end_time, 'HH:mm');

			if (now.isBefore(start)) {
				return `Mulai jam ${todaySchedule?.start_time}`;
			}

			if (now.isBetween(start, end)) {
				return `Expired Jam ${todaySchedule?.end_time}`;
			}

			return 'Expired';
		}
		return null;
	}, [data]);

	const handleClickUseVoucher = () => {
		if (isLoading) return;

    if (isEmptyData(values?.deliveryType) && data?.purpose === VOUCHER_GLOBAL_PURPOSE.DELIVERY) {
			return showError({
				title: 'Piih Pengiriman Terlebih Dahulu',
			});
		}
		sendAnalyticsEvent(data?.is_use ? 'Click Remove Voucher Global' : 'Click Add Voucher Global', data?.is_use ? 'voucher_remove_voucher_global' : 'voucher_add_voucher_global', `${data?.name}-${data?.nominal_voucher}`);
		handleUseVoucher(data);
	};

	return (
		<div key={`${type}_${data?.id}`} onClick={(e) => onOpenDetail('voucher_global')} className='h-full w-full relative mt-4 p-3'>
			<ImageLoader src={data?.image ?? ''} className={`shadow-md h-auto max-h-36 w-full rounded-t-xl object-cover object-center border-1 border-solid border-gray-100 bg-gray-200 transition-opacity duration-300 ${isDisabled ? 'opacity-50' : ''}`} />
			<div className={`flex justify-between p-4 rounded-b-xl shadow-md bg-white`}>
				<div className=''>
					<div className={`font-semibold text-sm text-gray-700 break-all transition-opacity duration-300 ${isDisabled ? 'opacity-50' : ''}`}>{data?.code ?? ''}</div>
					<p className='font-thin text-xs'>{data?.short_description}</p>
					<div className='mt-3 flex w-full'>
						<div className={`font-normal text-xs text-red-600 max-w-[70%] transition-opacity duration-300 ${isDisabled ? 'opacity-50' : ''}`}>{expired}</div>
						<div className='pl-2 text-blue-500'>T&C</div>
					</div>
				</div>
				<div className={`${isHiddenButton ? 'hidden' : 'flex'} flex-col justify-end min-w-fit`}>
					<button
						id={data?.is_use ? 'voucher_add_voucher_global' : 'voucher_remove_voucher_global'}
						disabled={isLoading || (data?.is_use ? false : isDisabled ? isDisabled : false)}
						aria-busy={isPending}
						onClick={(e) => {
							e.stopPropagation();
							handleClickUseVoucher();
						}}
						className={`min-w-[112px] px-8 h-10 rounded-full flex items-center justify-center transition-colors duration-200 ${
							!data?.is_use && isOneSmile ? 'text-white border-green-500 bg-green-500'
							: data?.is_use ? 'text-white border-red-500 bg-red-500' 
							: isDisabled ? 'text-white border-gray-200 bg-gray-200' 
							: 'text-white border-[var(--rose-violet)] bg-[var(--rose-violet)]'
						} ${isLoading && !isPending ? 'opacity-60 cursor-not-allowed' : ''} font-semibold text-sm`}>
						{isPending ? (
							<span className='inline-block h-4 w-4 rounded-full border-2 border-solid border-white border-t-transparent animate-spin' role='status' aria-label='Memproses' />
						) : data?.is_use ? (
							'Remove'
						) : (
							'Use Now'
						)}
					</button>
				</div>
			</div>
		</div>
	);
};

export default VoucherGlobal;

export const CouponVoucherGlobal = ({ classNameParent = '', classNameBody = '', classNameIcon = '', classNameLabel = '', classNameDesc = '', vouchers = [], handleClick = () => {}, item = {} }) => {
	if (!vouchers?.length) return null;
	const sortedData = [...vouchers].sort((a, b) => {
		if (a.purpose === 'PRODUCT' && b.purpose !== 'PRODUCT') return -1;
		if (a.purpose !== 'PRODUCT' && b.purpose === 'PRODUCT') return 1;
		return 0;
	});

	return (
		<div className={`w-full overflow-x-auto scrollbar-hide pt-1 -mr-80 ${classNameParent}`} onClick={() => handleClick(item || true)}>
			<div className='flex flex-row flex-nowrap gap-2 -mr-20'>
				{sortedData?.map((voucher, index) => {
          const type = voucher?.type === 'percentage';
					const diskon = voucher?.type === 'percentage' ? `${voucher?.value}%` : formatRupiah(voucher?.value);
					const maxDiskon = formatRupiah(voucher?.max_discount || 0);
					const title = voucher?.purpose === 'PRODUCT' ? (type ? `Diskon Menu ${diskon} up to ${maxDiskon}` : `Diskon Menu ${diskon}`) : type ? `Free Ongkir ${diskon} up to ${maxDiskon}` : `Free Ongkir ${diskon}`;
					const desc = voucher?.min_transaction > 0 ? `Min Spend ${formatRupiah(voucher?.min_transaction || 0)}` : 'Tanpa Min Spend';
					return (
						<div key={index} className={`flex-shrink-0 rounded-md border-solid border-1 border-gray-200 px-2 flex items-center gap-2 ${classNameBody}`}>
							<DiscountIcon className={`w-8 h-auto ${classNameIcon}`} />
							<div>
								<div className={`text-gray-700 font-semibold text-xxs ${classNameLabel}`}>{title}</div>
								<div className={`text-gray-700 font-normal text-[8px] ${classNameDesc}`}>{desc}</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export const CouponVoucherGlobalList = ({ vouchers = [], isHiddenButton = false, handleVoucherDetail = () => {} }) => {
	if (!vouchers?.length) return null;
	return (
		<div className='h-full overflow-y-scroll overflow-x-hidden scrollbar-hide'>
			<div className={`mt-4 h-full`}>
				<div className='text-base font-semibold text-gray-900 mx-4'>Voucher List</div>
				{vouchers?.map((voucher, index) => {
					return (
						<VoucherGlobal
							key={index}
							data={voucher}
							isHiddenButton={isHiddenButton}
							onOpenDetail={(type) => {
								handleVoucherDetail(true, voucher, type);
							}}
						/>
					);
				})}
			</div>
		</div>
	);
};